import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-insure-home',
    templateUrl: './insure-home.component.html',
    styleUrls: ['./insure-home.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InsureHomeComponent {

}
